import { Locale } from '@headless-workspace/config';

const CACHE_KEY_SEPARATOR = '-';

export const createLocalizedCacheKey = (key: string, locale: Locale): string => {
    return `${locale}${CACHE_KEY_SEPARATOR}${key}`;
};
